module.exports = __webpack_public_path__ + "sit/20260418112858/img/url-app.d88da72d.png";